webpackJsonp([0],{

/***/ "5P/H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/congratulation.cc989eb.png";

/***/ }),

/***/ "98HQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("Ln0X");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var CIRCLE_ANGLE = 360;

var config = {
  // 总旋转时间
  duration: 4000,
  // 旋转圈数
  circle: 8,
  mode: 'ease-in-out'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      referrer: '0x1f294494ac5e9caa3e4e913c7159df3e943b05d8',
      count: 3, // 剩余抽奖次数
      duration: 3000, // 转盘旋转时间
      prizeList: [], // 奖品列表
      rotateAngle: 0, // 旋转角度
      index: 0,
      prize: null,
      needShare: null
    };
  },
  created: function created() {
    // 初始化一些值
    this.angleList = [];
    // 是否正在旋转
    this.isRotating = false;
    // 基本配置
    this.config = config;

    // 获取奖品列表
    this.initPrizeList();

    this.referrer = this.getQueryVariable('ref');
    console.log('Referrer: ', this.referrer);
  },

  computed: {
    link: function link() {
      return 'https://wave.cash/airdrop?ref=' + this.referrer;
    },
    win: function win() {
      if (this.prize && this.prize.isPrize === 1) {
        return true;
      } else {
        return false;
      }
    },
    rotateStyle: function rotateStyle() {
      return '\n        -webkit-transition: transform ' + this.config.duration + 'ms ' + this.config.mode + ';\n        transition: transform ' + this.config.duration + 'ms ' + this.config.mode + ';\n        -webkit-transform: rotate(' + this.rotateAngle + 'deg);\n            transform: rotate(' + this.rotateAngle + 'deg);';
    },
    toastTitle: function toastTitle() {
      return this.win ? "恭喜您，获得: 50,000 WAVE " : "再接再厉！";
    },
    toastBody: function toastBody() {
      if (this.win) {
        var h = '<span class="numbervalue">' + 123 + '€</span>';
        return h;
      } else {
        var _h = '';
        return _h;
      }
    },
    toastIcon: function toastIcon() {
      return this.win ? __webpack_require__("5P/H") : __webpack_require__("xt23");
    }
  },
  methods: {
    doCopy: function doCopy(msg) {
      this.$copyText(msg).then(function (e) {
        alert('已复制链接至剪贴板, 请使用BSC钱包打开链接.');
        console.log(e);
      }, function (e) {
        alert('Can not copy');
        console.log(e);
      });
    },
    getQueryVariable: function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    initPrizeList: function initPrizeList() {
      // 这里可以发起请求，从服务端获取奖品列表
      // 这里使用模拟数据

      this.prizeList = this.formatPrizeList(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* prizeList */]);
    },

    // 格式化奖品列表，计算每个奖品的位置
    formatPrizeList: function formatPrizeList(list) {
      // 记录每个奖的位置
      var angleList = [];

      var l = list.length;
      // 计算单个奖项所占的角度
      var average = CIRCLE_ANGLE / l;

      var half = average / 2;

      // 循环计算给每个奖项添加style属性
      list.forEach(function (item, i) {

        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        var angle = -(i * average + half);
        // 增加 style
        item.style = '-webkit-transform: rotate(' + angle + 'deg);\n                      transform: rotate(' + angle + 'deg);';

        // 记录每个奖项的角度范围
        angleList.push(i * average + half);
      });

      this.angleList = angleList;

      return list;
    },
    showShare: function showShare() {
      this.needShare = true;
    },
    beginRotate: function beginRotate() {
      // 添加次数校验

      if (this.count === 0) {
        this.showShare();
        return;
      }

      // 开始抽奖
      // 这里这里向服务端发起请求，得到要获得的奖
      // 可以返回下标，也可以返回奖品 id，通过查询 奖品列表，最终得到下标

      // 随机获取下标
      // this.index = this.random(this.prizeList.length - 1);
      this.index = (3 - this.count) * 3;

      // 减少剩余抽奖次数
      this.count--;

      // 开始旋转
      this.rotating();
    },
    random: function random(max) {
      var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return parseInt(Math.random() * (max - min + 1) + min);
    },
    rotating: function rotating() {
      var _this = this;

      var isRotating = this.isRotating,
          angleList = this.angleList,
          config = this.config,
          rotateAngle = this.rotateAngle,
          index = this.index;


      if (isRotating) return;

      this.isRotating = true;

      // 计算角度
      var angle =
      // 初始角度
      rotateAngle +
      // 多旋转的圈数
      config.circle * CIRCLE_ANGLE +
      // 奖项的角度
      angleList[index] - rotateAngle % CIRCLE_ANGLE;

      this.rotateAngle = angle;

      // 旋转结束后，允许再次触发
      setTimeout(function () {

        _this.rotateOver();
      }, config.duration + 1000);
    },
    rotateOver: function rotateOver() {
      this.isRotating = false;

      this.prize = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* prizeList */][this.index];

      console.log(this.prize, this.index);
    },

    //关闭弹窗
    closeToast: function closeToast() {
      this.prize = null;
      this.needShare = null;
    }
  }
});

/***/ }),

/***/ "D/3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_luckywheel_vue__ = __webpack_require__("98HQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce61183a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_luckywheel_vue__ = __webpack_require__("qUI7");
function injectStyle (ssrContext) {
  __webpack_require__("uwS2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce61183a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_luckywheel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce61183a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_luckywheel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J6lm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Ln0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prizeList; });
var prizeList = [{
  icon: __webpack_require__("gA3z"), // 奖品图片
  name: "再接再厉", // 奖品名称
  isPrize: 0 // 该奖项是否为奖品
}, {
  icon: __webpack_require__("vTjI"),
  name: "1 BNB",
  isPrize: 1
}, {
  icon: __webpack_require__("Wwhm"),
  name: "0.1 ETH",
  isPrize: 1
}, {
  icon: __webpack_require__("J6lm"),
  name: "WAVE",
  isPrize: 1
}, {
  icon: __webpack_require__("pi3s"),
  name: "10 USDT",
  isPrize: 1
}, {
  icon: __webpack_require__("pOA9"),
  name: "1 LTC",
  isPrize: 1
}, {
  icon: __webpack_require__("gA3z"),
  name: "再接再厉",
  isPrize: 0
}, {
  icon: __webpack_require__("WraW"),
  name: "0.01BTC",
  isPrize: 1
}];

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae2acc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Q5PP");
function injectStyle (ssrContext) {
  __webpack_require__("mODg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae2acc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clipboard2__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_clipboard2___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Q5PP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('lucky-wheel')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-pic"},[_c('img',{attrs:{"src":"static/screen.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WraW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Wwhm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gA3z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/give_up.42e8aa8.png";

/***/ }),

/***/ "mODg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pOA9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURUxpcQB/fzNcnDNcnAAA/zRcnT8/f1VVqjNdnDRdnAAAADRcnTNdnTNdnDNdm39/fzNdnjRdnTNmmTRdnTVjojNcmzVVlTNbmzVfoTNcnDZgojVgojVfoTRenzNmmThVqjNMkzdjpzVfoDRdnTRdni5cojRbnTNcnDNdnTNioTRdnTNcnThkqTNdnjRcnDNdnTVfoTVcnDNcnDNdnTRfoD1VVTVfoDNcnDRfoTVfoGqa/zVenzNcnDVfoDReoDRfnzNdnjRdnDRenzNdnTNcnDVenzNdnjRcnS5cizVgoTRXlTReoDVdnzJZmjZenTNenDRcnDVeoTRdnjRenjRdnTNcnjReoDNenjNmqjNepTRdnjRdnjFemzVfoDRdnTNbmzNcnTNdmzVcnDNbmzVfoDFYkzRenzNbmTlcojNdnDRdnDNdnTNcnDRdnTRdnDVenzVdnzVdnTRdnf///zdfnjdipfz9/idTl3mUvjVdnf7+/jZfnv39/jVenf7+/zdgnzhkqTJcnDpioDdipvz8/ebr8zdjpzVeniZSljVfoDVfoS5ZmitWmThkqP3+/iVRli1YmjRenjZenjJbnDdjqDZgo/7//yhUlzZhpDZgoilVmDlhnzNcndLb6TdjpjBamzZho9Pc6j1koSlUmGiHtvv8/S9ZmzFbnPn6/ChTlzRdnoCawjVgoe3x93iTvixXmTdfn4aexC1XmfX3+uPo8Vt8sCdSl/b4+/Dz+MDN4WGCs7HB2qq71vP2+StWmIefxeXr8/z9/TdipOfs9Pr7/HqVv8jT5U9yq5eszVd5rq2+2Elup0xwqeTq8oOcw0ZrpZWqzN3k70FnozFamzhgn3OQu6K10rTD28fS5Jywz1V3raO20tTd6ujs89rh7Yqixoykx+Hn8Ovv9URppNvi7sXR42+MuaS3087X56y913CNukFoo7nI3UVqpVZ4rl5/sYSdwyBNk7vJ3nuVv5Gnyo6lyTtjoCRRlWGAssvW5nKOu73K387Y5xtJkUdspk1xqc9xuHgAAABydFJOUwAC+/0B/QQD/P4B+vv7/AJK/gUrDvwXb0tx/vf5/AoJCv7YXGILee5HEL9f/i3+478ww99pA9nX0tsBbqjJpKZySOqLSl9maAvXHcjKHip3pqe84/lFiXcPEr/6Lr3gbdhfW8XTGssZFqmmp+fmieuLi+6BIMEAAAW4SURBVFjDjVd3XBNnGP5IDrIIUxEciAxFBfdGRRFbqXvW0b33uEug4cjA2CSEACFskL1BRQRx1NXWUeuotq4Ou/fee313lwu5y3eB5x9+JHnf+97ne+593wcAT8glEurPkNCNMRGrV0fEbFw1hPpfIpGDwUBORY8P2rRu/YacOjVEXc6G9es2BW2hcgwiBQz3C1+YojYYrYUyXymEb3Ch1WhQpywMktBfe4UPBiJnzCk35YiVUlkw7kSwTKoU55jK58yIApiPt3g/AJbOKi4RS2W4B2RScUlx9FL6RwLAZoKpU0wVQ31xAfgOrTDdeQd1TPTxAUgaoQ4QDKdTSI0jkuifotiLSs7rkOIDQFqYtzAKxaUEhC0wKPm1k2YtDdKNC6VheZhnBglYmVaj4D9Oa7O35FI4lu32qcKUdhs/gw8IizaK+PGkrbu6ur6+vrr+C87nImP0I1wesMDIFTUe8dqihqMEg91XdmrcM5iWjw7EOPc/3+ARj5ONTURzFsTJ9CMWPfcMhjXuepCAYQaFJ+H6gs+IHdTzs4ir7SrudwrD3f00BILQkaMQ2sOLPibyYbyOOPpRrZany1EjV4F5zgQz500zIu7f0XU2q5Q6QDrxSSXJ/zbAOE0uYQuIKfbHURW8z1Swg3iPRwEFpek+hgYMi5w+HKVf0nYaPpzm4K19Dk9VD58+GsPoG7g1bygiXtvyWg8sn4A0vFuEEnVA3i30EbCQ2SWoA6gy9kD66QreLtCjXqy62SGYHOZYrBajHqC3vMBQkEk0eXJIQfxSPAyXgMfHoCjUZFfdhLHUJe5uKNKiEviPWUNpYci4HJQGyMrDdDzxIvE1X0WsFnLGbYYcBAlUUPAmU0E60WnRo3uDWB0PEyxJUOLIS3iH5rCUaDufa0YnECU8BRNMUKO6kMN+ppnRAFFtNwt1J+MESMGTVhnyDrpZGb7St92MFAI+adfkOJCoKAxGcdh4iJGhjvj9t/Z9v6KP0KEIBfHIA2jfeP2gU4aXa89cPN2dsRd5D9YgMLEcKcOyTxkZ6ogLf0Ay9tuQUvKtmwgWITmsKjvCUABvASbpbRVgUT0MjPVMQOod+459QPcSGpmXL6IPABPcjkpgs9jP/Zyvo5+vO3Djl7O4TYsLJkCUsP/S323Oh2cR3/9Q1oWTuHAJfBJVZVeZSIaAtnO1VQ7hUQlJ5F+jvuA6Tb7zAJ/bHV4GpcyaChJFHCFBARzoudF5je0llwr0XhJQQtr8BOcI5pb/Ov+1//OXU4Y6AQG4SZn/Mmlb+2qLXN2w1+x11FMvE3yduQ1Jo7rS/idbwRGLtwqUCUuQDUVveZUdaV+WqbwkEKsXUyuhR0vbSfY6R9rBr1rNGg54LW08NZfm85oqafuOucZ04lCGNpsLLaepPgbD/Txq0BdcYrvh8a6G7RxU5XLa+mJqsmAh93AHi9le7RQi8eGJm8+748KJ442ua/UtoQeLx2gz555vI0oJAVzrF5ZrtGFxd7kP172WTudMhTRmcpCfnnnYNaRcwxXycK/7eCfLfoTDBIlM4uWqbI1rvMewW06gz/39aoSb1W72XeJjh+56hsqlwmlwNUasOKrGpqzmdCSyThI/9alcK04oDEQsWdRQFkTPN7VmxJIF5H7gUXbN07Q2ndrzHBJ7Tn3LDjmRYT5n7cfmRT7ELpqaygxBsENOZFrBXTTh3vrwXHbVJVWCcLhW3TD+yg+X7Vk1CnxQUNSkrUSt6w8uMIhkA4fLRIYFYWjDsGxtXuFgDEdyFNq8waIWDWh5AowjIgQsD6Ac3QCmK6DCNGWqoOlibF/s3OIKYds3N9ab7aPKkIO4pAfU0Hj6Syf1G89JUn9oPNVzZiwbwHgy1jckfO3T0Ovu6nBaX1nhLuiEU5LDQwa2vqz53hL+zNbJ26zllPkut26bvPXZ8MGabzf7n5gaGzF2bERsaqIX+/8/rDeCbjJNPnAAAAAASUVORK5CYII="

/***/ }),

/***/ "pi3s":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "qUI7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"lucky-wheel"},[_c('div',{staticClass:"lucky-title"}),_vm._v(" "),_c('div',{staticClass:"wheel-main"},[_c('div',{staticClass:"wheel-pointer",on:{"click":function($event){_vm.beginRotate()}}}),_vm._v(" "),_c('div',{staticClass:"wheel-bg",style:(_vm.rotateStyle)},[_c('div',{staticClass:"prize-list"},_vm._l((_vm.prizeList),function(item,index){return _c('div',{key:index,staticClass:"prize-item",style:(item.style)},[_c('div',{staticClass:"prize-pic"},[_c('img',{attrs:{"src":item.icon}})]),_vm._v(" "),_c('div',{staticClass:"prize-type"},[_vm._v(_vm._s(item.name))])])}))])])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-bg"}),_vm._v(" "),_c('div',{staticClass:"bg-p"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"count"},[_vm._v("今日免费抽奖次数： "+_vm._s(_vm.count))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.prize),expression:"prize"}],staticClass:"toast"},[_c('div',{staticClass:"toast-container"},[_c('img',{staticClass:"toast-picture",attrs:{"src":_vm.toastIcon}}),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":function($event){_vm.closeToast()}}}),_vm._v(" "),_c('div',{staticClass:"toast-title"},[_vm._v(_vm._s(_vm.toastTitle))]),_vm._v(" "),(_vm.win)?_c('div',{staticClass:"win-content"},[_vm._v(" 请复制领奖链接并使用币安智能链(BSC)钱包领奖: "+_vm._s(_vm.link.substring(0,18) + "...")+" ")]):_vm._e(),_vm._v(" "),(_vm.win)?_c('div',{staticClass:"win-content"},[_vm._v(" 冲浪币(WAVE)是知名网络社区神奈川冲浪里的社区代币, 社区成员数量庞大.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toast-btn"},[(_vm.win)?_c('div',{staticClass:"toast-cancel",on:{"click":function($event){_vm.doCopy(_vm.link)}}},[_vm._v("领奖")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toast-cancel",on:{"click":_vm.closeToast}},[_vm._v("关闭")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.needShare),expression:"needShare"}],staticClass:"toast"},[_c('div',{staticClass:"toast-container"},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.closeToast()}}}),_vm._v(" "),_c('div',{staticClass:"toast-title"},[_vm._v("没有剩余抽奖机会")]),_vm._v(" "),_c('div',{staticClass:"win-content"},[_vm._v(" 请分享本页面并获得更多抽奖机会 ")]),_vm._v(" "),_c('div',{staticClass:"toast-btn"},[_c('div',{staticClass:"toast-cancel",on:{"click":_vm.closeToast}},[_vm._v("关闭")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.prize),expression:"prize"}],staticClass:"toast-mask"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('div',{staticClass:"tip-title"},[_vm._v("活动规则")]),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_c('p',[_vm._v("1.分享抽奖链接至三个群，即可获得三次幸运大转盘的机会，仅限当天有效，过期作废")]),_vm._v(" "),_c('p',[_vm._v("2.抽中奖品后请立即到指定网站领取，过期作废")]),_vm._v(" "),_c('p',[_vm._v("3.最终解释权归网站所有")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uwS2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vTjI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_luckywheel__ = __webpack_require__("D/3C");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    LuckyWheel: __WEBPACK_IMPORTED_MODULE_0__components_luckywheel__["a" /* default */]
  }
});

/***/ }),

/***/ "xt23":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sorry.f97510f.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.48580f79a7bc43995796.js